/**
 * Generated from ch8_p05.fla
 */
export function ch8_p05(this: Ich8_p05) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg.call(bg[0] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg);
		bg[0].x = 3072;
		bg[0].y = 382.5;
		bg[0].width = 2048.00;
		bg[0].height = 765.00;
		bg[0].alpha = 1;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2.call(bg[1] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2);
		bg[1].x = 4544;
		bg[1].y = 381.5;
		bg[1].width = 896.00;
		bg[1].height = 763.00;
		bg[1].alpha = 1;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	if (!bg[2] && bg.elementFactory) {
		bg[2] = bg.elementFactory(2,undefined);
	}
	if (bg[2]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy.call(bg[2] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy);
		bg[2].x = 1024;
		bg[2].y = 382.5;
		bg[2].width = 2048.00;
		bg[2].height = 765.00;
		bg[2].alpha = 1;
		if (bg[2].onLayout) bg[2].onLayout();
	}
	const mg = this.mg;
	if (!mg[0] && mg.elementFactory) {
		mg[0] = mg.elementFactory(0,undefined);
	}
	if (mg[0]) {
		ch8_p05_chp8_p05_midgrounda.call(mg[0] as Ich8_p05_chp8_p05_midgrounda);
		mg[0].x = 5493;
		mg[0].y = 493.5;
		mg[0].width = 2048.00;
		mg[0].height = 583.50;
		mg[0].alpha = 1;
		if (mg[0].onLayout) mg[0].onLayout();
	}
	if (!mg[1] && mg.elementFactory) {
		mg[1] = mg.elementFactory(1,undefined);
	}
	if (mg[1]) {
		ch8_p05_chp8_p05_midgroundb.call(mg[1] as Ich8_p05_chp8_p05_midgroundb);
		mg[1].x = 2603.5;
		mg[1].y = 493.75;
		mg[1].width = 1111.00;
		mg[1].height = 583.50;
		mg[1].alpha = 1;
		if (mg[1].onLayout) mg[1].onLayout();
	}
	if (!mg[2] && mg.elementFactory) {
		mg[2] = mg.elementFactory(2,undefined);
	}
	if (mg[2]) {
		ch8_p05_chp8_p05_midgroundc.call(mg[2] as Ich8_p05_chp8_p05_midgroundc);
		mg[2].x = 4183;
		mg[2].y = 493.75;
		mg[2].width = 2048.00;
		mg[2].height = 583.50;
		mg[2].alpha = 1;
		if (mg[2].onLayout) mg[2].onLayout();
	}
	if (!mg[3] && mg.elementFactory) {
		mg[3] = mg.elementFactory(3,undefined);
	}
	if (mg[3]) {
		ch8_p05_chp8_p05_midgrounda.call(mg[3] as Ich8_p05_chp8_p05_midgrounda);
		mg[3].x = 10700;
		mg[3].y = 494;
		mg[3].width = 2048.00;
		mg[3].height = 583.50;
		mg[3].alpha = 1;
		if (mg[3].onLayout) mg[3].onLayout();
	}
	if (!mg[4] && mg.elementFactory) {
		mg[4] = mg.elementFactory(4,undefined);
	}
	if (mg[4]) {
		ch8_p05_chp8_p05_midgroundb.call(mg[4] as Ich8_p05_chp8_p05_midgroundb);
		mg[4].x = 7810.5;
		mg[4].y = 494.25;
		mg[4].width = 1111.00;
		mg[4].height = 583.50;
		mg[4].alpha = 1;
		if (mg[4].onLayout) mg[4].onLayout();
	}
	if (!mg[5] && mg.elementFactory) {
		mg[5] = mg.elementFactory(5,undefined);
	}
	if (mg[5]) {
		ch8_p05_chp8_p05_midgroundc.call(mg[5] as Ich8_p05_chp8_p05_midgroundc);
		mg[5].x = 9390;
		mg[5].y = 494.25;
		mg[5].width = 2048.00;
		mg[5].height = 583.50;
		mg[5].alpha = 1;
		if (mg[5].onLayout) mg[5].onLayout();
	}
	const water = this.water;
	if (!water[0] && water.elementFactory) {
		water[0] = water.elementFactory(0,undefined);
	}
	if (water[0]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[0] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[0].x = 4505;
		water[0].y = 643.25;
		water[0].width = 530.00;
		water[0].height = 249.50;
		water[0].alpha = 1;
		if (water[0].onLayout) water[0].onLayout();
	}
	if (!water[1] && water.elementFactory) {
		water[1] = water.elementFactory(1,undefined);
	}
	if (water[1]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[1] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[1].x = 5035;
		water[1].y = 643.25;
		water[1].width = 530.00;
		water[1].height = 249.50;
		water[1].alpha = 1;
		if (water[1].onLayout) water[1].onLayout();
	}
	if (!water[2] && water.elementFactory) {
		water[2] = water.elementFactory(2,undefined);
	}
	if (water[2]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[2] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[2].x = 3975;
		water[2].y = 643.25;
		water[2].width = 530.00;
		water[2].height = 249.50;
		water[2].alpha = 1;
		if (water[2].onLayout) water[2].onLayout();
	}
	if (!water[3] && water.elementFactory) {
		water[3] = water.elementFactory(3,undefined);
	}
	if (water[3]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[3] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[3].x = 3445;
		water[3].y = 643.25;
		water[3].width = 530.00;
		water[3].height = 249.50;
		water[3].alpha = 1;
		if (water[3].onLayout) water[3].onLayout();
	}
	if (!water[4] && water.elementFactory) {
		water[4] = water.elementFactory(4,undefined);
	}
	if (water[4]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[4] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[4].x = 2915;
		water[4].y = 643.25;
		water[4].width = 530.00;
		water[4].height = 249.50;
		water[4].alpha = 1;
		if (water[4].onLayout) water[4].onLayout();
	}
	if (!water[5] && water.elementFactory) {
		water[5] = water.elementFactory(5,undefined);
	}
	if (water[5]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[5] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[5].x = 2385;
		water[5].y = 643.25;
		water[5].width = 530.00;
		water[5].height = 249.50;
		water[5].alpha = 1;
		if (water[5].onLayout) water[5].onLayout();
	}
	if (!water[6] && water.elementFactory) {
		water[6] = water.elementFactory(6,undefined);
	}
	if (water[6]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[6] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[6].x = 1855;
		water[6].y = 643.25;
		water[6].width = 530.00;
		water[6].height = 249.50;
		water[6].alpha = 1;
		if (water[6].onLayout) water[6].onLayout();
	}
	if (!water[7] && water.elementFactory) {
		water[7] = water.elementFactory(7,undefined);
	}
	if (water[7]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[7] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[7].x = 1325;
		water[7].y = 643.25;
		water[7].width = 530.00;
		water[7].height = 249.50;
		water[7].alpha = 1;
		if (water[7].onLayout) water[7].onLayout();
	}
	if (!water[8] && water.elementFactory) {
		water[8] = water.elementFactory(8,undefined);
	}
	if (water[8]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[8] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[8].x = 795;
		water[8].y = 643.25;
		water[8].width = 530.00;
		water[8].height = 249.50;
		water[8].alpha = 1;
		if (water[8].onLayout) water[8].onLayout();
	}
	if (!water[9] && water.elementFactory) {
		water[9] = water.elementFactory(9,undefined);
	}
	if (water[9]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[9] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[9].x = 265;
		water[9].y = 643.25;
		water[9].width = 530.00;
		water[9].height = 249.50;
		water[9].alpha = 1;
		if (water[9].onLayout) water[9].onLayout();
	}
	if (!water[10] && water.elementFactory) {
		water[10] = water.elementFactory(10,undefined);
	}
	if (water[10]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[10] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[10].x = 5565;
		water[10].y = 643.25;
		water[10].width = 530.00;
		water[10].height = 249.50;
		water[10].alpha = 1;
		if (water[10].onLayout) water[10].onLayout();
	}
	if (!water[11] && water.elementFactory) {
		water[11] = water.elementFactory(11,undefined);
	}
	if (water[11]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[11] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[11].x = 6095;
		water[11].y = 643.25;
		water[11].width = 530.00;
		water[11].height = 249.50;
		water[11].alpha = 1;
		if (water[11].onLayout) water[11].onLayout();
	}
	if (!water[12] && water.elementFactory) {
		water[12] = water.elementFactory(12,undefined);
	}
	if (water[12]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[12] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[12].x = 6625;
		water[12].y = 643.25;
		water[12].width = 530.00;
		water[12].height = 249.50;
		water[12].alpha = 1;
		if (water[12].onLayout) water[12].onLayout();
	}
	if (!water[13] && water.elementFactory) {
		water[13] = water.elementFactory(13,undefined);
	}
	if (water[13]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[13] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[13].x = 7155;
		water[13].y = 643.25;
		water[13].width = 530.00;
		water[13].height = 249.50;
		water[13].alpha = 1;
		if (water[13].onLayout) water[13].onLayout();
	}
	if (!water[14] && water.elementFactory) {
		water[14] = water.elementFactory(14,undefined);
	}
	if (water[14]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[14] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[14].x = 7685;
		water[14].y = 643.25;
		water[14].width = 530.00;
		water[14].height = 249.50;
		water[14].alpha = 1;
		if (water[14].onLayout) water[14].onLayout();
	}
	if (!water[15] && water.elementFactory) {
		water[15] = water.elementFactory(15,undefined);
	}
	if (water[15]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[15] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[15].x = 8215;
		water[15].y = 643.25;
		water[15].width = 530.00;
		water[15].height = 249.50;
		water[15].alpha = 1;
		if (water[15].onLayout) water[15].onLayout();
	}
	if (!water[16] && water.elementFactory) {
		water[16] = water.elementFactory(16,undefined);
	}
	if (water[16]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[16] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[16].x = 8745;
		water[16].y = 643.25;
		water[16].width = 530.00;
		water[16].height = 249.50;
		water[16].alpha = 1;
		if (water[16].onLayout) water[16].onLayout();
	}
	if (!water[17] && water.elementFactory) {
		water[17] = water.elementFactory(17,undefined);
	}
	if (water[17]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[17] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[17].x = 9275;
		water[17].y = 643.25;
		water[17].width = 530.00;
		water[17].height = 249.50;
		water[17].alpha = 1;
		if (water[17].onLayout) water[17].onLayout();
	}
	if (!water[18] && water.elementFactory) {
		water[18] = water.elementFactory(18,undefined);
	}
	if (water[18]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[18] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[18].x = 9805;
		water[18].y = 643.25;
		water[18].width = 530.00;
		water[18].height = 249.50;
		water[18].alpha = 1;
		if (water[18].onLayout) water[18].onLayout();
	}
	if (!water[19] && water.elementFactory) {
		water[19] = water.elementFactory(19,undefined);
	}
	if (water[19]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[19] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[19].x = 10335;
		water[19].y = 643.25;
		water[19].width = 530.00;
		water[19].height = 249.50;
		water[19].alpha = 1;
		if (water[19].onLayout) water[19].onLayout();
	}
	if (!water[20] && water.elementFactory) {
		water[20] = water.elementFactory(20,undefined);
	}
	if (water[20]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[20] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[20].x = 10865;
		water[20].y = 643.25;
		water[20].width = 530.00;
		water[20].height = 249.50;
		water[20].alpha = 1;
		if (water[20].onLayout) water[20].onLayout();
	}
	if (!water[21] && water.elementFactory) {
		water[21] = water.elementFactory(21,undefined);
	}
	if (water[21]) {
		ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile.call(water[21] as Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile);
		water[21].x = 11395;
		water[21].y = 643.25;
		water[21].width = 530.00;
		water[21].height = 249.50;
		water[21].alpha = 1;
		if (water[21].onLayout) water[21].onLayout();
	}
	const holly = this.holly;
	ch8_p05_holly.call(this.holly);
	holly.x = 600.25;
	holly.y = 616;
	holly.width = 542.50;
	holly.height = 284.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const treeBack = this.treeBack;
	ch8_p05_chp8_p05_treeback.call(this.treeBack);
	treeBack.x = 9804;
	treeBack.y = 303.5;
	treeBack.width = 564.00;
	treeBack.height = 571.00;
	treeBack.alpha = 1.00;
	if (treeBack.onLayout) treeBack.onLayout();
	const lamb = this.lamb;
	ch8_p05_chp8_p05_lamb.call(this.lamb);
	lamb.x = 9751.5;
	lamb.y = -209;
	lamb.width = 175.00;
	lamb.height = 703.40;
	lamb.alpha = 1.00;
	if (lamb.onLayout) lamb.onLayout();
	const treeFront = this.treeFront;
	ch8_p05_chp8_p05_treefront.call(this.treeFront);
	treeFront.x = 9709;
	treeFront.y = 0;
	treeFront.width = 778.00;
	treeFront.height = 93.90;
	treeFront.alpha = 1.00;
	if (treeFront.onLayout) treeFront.onLayout();
	return this;
}
function ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg(this: Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2(this: Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_bgcopy2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy(this: Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_bgcopy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_midgrounda(this: Ich8_p05_chp8_p05_midgrounda) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_midgrounda.png", 2.682, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_midgroundb(this: Ich8_p05_chp8_p05_midgroundb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_midgroundb.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_midgroundc(this: Ich8_p05_chp8_p05_midgroundc) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_midgroundc.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile(this: Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile) {
	if (this.setLayoutTexture) this.setLayoutTexture("WaterTile.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_holly(this: Ich8_p05_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_treeback(this: Ich8_p05_chp8_p05_treeback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_treeback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_lamb(this: Ich8_p05_chp8_p05_lamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_lamb.png", 0.500, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p05_chp8_p05_treefront(this: Ich8_p05_chp8_p05_treefront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p05_treefront", 0.500, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich8_p05Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p05Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p05Sprite extends Ich8_p05Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p05Text extends Ich8_p05Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p05Polygon extends Array<number> {
}
interface Ich8_p05 {
	readonly bg: Ich8_p05Array<Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg|Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2|Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy>;
	readonly mg: Ich8_p05Array<Ich8_p05_chp8_p05_midgrounda|Ich8_p05_chp8_p05_midgroundb|Ich8_p05_chp8_p05_midgroundc>;
	readonly water: Ich8_p05Array<Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile>;
	readonly holly: Ich8_p05_holly;
	readonly treeBack: Ich8_p05_chp8_p05_treeback;
	readonly lamb: Ich8_p05_chp8_p05_lamb;
	readonly treeFront: Ich8_p05_chp8_p05_treefront;
}
interface Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bg extends Ich8_p05Sprite {
}
interface Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy2 extends Ich8_p05Sprite {
}
interface Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_bgcopy extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_midgrounda extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_midgroundb extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_midgroundc extends Ich8_p05Sprite {
}
interface Ich8_p05_hh_ch8_72dpi_p05flattenedpsdAssetchp8_p05_foregroundWaterTile extends Ich8_p05Sprite {
}
interface Ich8_p05_holly extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_treeback extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_lamb extends Ich8_p05Sprite {
}
interface Ich8_p05_chp8_p05_treefront extends Ich8_p05Sprite {
}
